import { useState } from 'react'

import { AccordionAnimatedContent } from '../../Accordion'
import { getBirdviewAttentionEmptyTextKey } from '../DashboardBirdview.utils'

import { useBirdviewAttentionAge } from './BirdviewAttentionRow.hooks'
import { BirdviewAttentionRowBody } from './BirdviewAttentionRowBody'
import { BirdviewAttentionRowHeader } from './BirdviewAttentionRowHeader'

import * as styles from './BirdviewAttentionRow.module.css'

function BirdviewAttentionRow({
  item,
  requestActions,
  onLoadGroup,
  onOpenItem,
}) {
  const [isOpen, setIsOpen] = useState(Boolean(item.isOpenByDefault))

  const { age, count, extra, handleRetry, handleSelectAge, items, state } =
    useBirdviewAttentionAge({ group: item, onLoadGroup })

  function handleToggle() {
    setIsOpen(open => !open)
  }

  return (
    <div className={styles.row}>
      <BirdviewAttentionRowHeader
        age={age}
        count={count}
        isOpen={isOpen}
        item={item}
        onSelectAge={handleSelectAge}
        onToggle={handleToggle}
      />
      <AccordionAnimatedContent isOpen={isOpen}>
        <BirdviewAttentionRowBody
          emptyTextKey={getBirdviewAttentionEmptyTextKey(age)}
          extra={extra}
          items={items}
          requestActions={requestActions}
          state={state}
          onOpenItem={onOpenItem}
          onRetry={handleRetry}
        />
      </AccordionAnimatedContent>
    </div>
  )
}

export default BirdviewAttentionRow
